import React, { useState, useEffect } from "react";

import {
  BrowserEdge,
  Chat,
  Envelope,
  Facebook,
  Heart,
  Instagram,
  Linkedin,
  PhoneFill,
  ShareFill,
  Star,
  StarFill,
  StarHalf,
  TelephoneFill,
  ThreeDots,
  Tiktok,
  Twitter,
} from "react-bootstrap-icons";

import ExampleProfile from "../../assets/ExamplePage/ExampleProfile.png";
import Example1 from "../../assets/ExamplePage/Example1.png";
import Example2 from "../../assets/ExamplePage/Example2.png";
import Example3 from "../../assets/ExamplePage/Example3.png";
import Example4 from "../../assets/ExamplePage/Example4.png";
import Example5 from "../../assets/ExamplePage/Example5.png";
import Example6 from "../../assets/ExamplePage/Example6.png";
import Example7 from "../../assets/ExamplePage/Example7.png";
import Post1 from "../../assets/ExamplePage/Post1.png";
import Post2 from "../../assets/ExamplePage/Post2.png";
import Post3 from "../../assets/ExamplePage/Post3.png";
// import "./OneClub.css";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import { NavDropdown } from "react-bootstrap";

import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";

export default function OneClub() {
  const [user, setUser] = useState(true); // Placeholder
  const [setFollowClubModal] = useState(() => () => {});
  const [setShareClubModal] = useState(() => () => {});
  const [setReportClubModal] = useState(() => () => {});
  const [setProfileImgModal] = useState(() => () => {});
  const [setShowReviews] = useState(() => () => {});
  const [isLoading] = useState(false);
  const [club] = useState({ image: null });
  const [images, setImages] = useState([]);



  const [fullStars] = useState(4);
  const [hasHalfStar] = useState(true);
  const [averageRating] = useState(4.5);
  const [totalReviews] = useState(20);

  const fetchData = async () => {
    const imageResponse = await axios.get(
      `${ApiConnectionString}/api/images?ClubId=1&ClubImage=true`
    );
    const orderedImages = imageResponse.data.sort(
      (a, b) => a.clubImageIndex - b.clubImageIndex
    );

    setImages(orderedImages);
  };

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container bg-white">
      <button
        className="floating-back-button"
        onClick={() => window.history.back()}
      >
        ← Back
      </button>
      <div className="d-flex justify-content-end mb-2">
        <div className="d-flex align-items-center mb-0 my-2">
          <div>
            <Heart
              size={20}
              className="mb-0 pointer"
              onClick={() => setFollowClubModal(true)}
            />
          </div>

          <ShareFill
            onClick={() => setShareClubModal(true)}
            size={20}
            className="mb-0 mx-3 pointer"
          />

          <NavDropdown
            title={<ThreeDots size={25} className="pointer" />}
            className="dropdown-toggle mb-0"
          ></NavDropdown>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="row mx-4 mt-0">
            <div className="col-12 col-md-6">
              {!isLoading && (
                <div
                  className="circle-crop image-container pointer"
                  onClick={() => club.image && setProfileImgModal(true)}
                >
                  <img src={ExampleProfile} alt="Club Image" className="mt-0" />
                </div>
              )}
              <p className="text-muted mb-0 mt-4">Joined July 2025</p>
              <p className="fontSize30 fw-bold mb-0">Example Name</p>
              <p>Example Address</p>

              <div className="pointer d-flex mb-0">
                <p className="mb-0">Send Message</p>
                <Chat size={25} className="mx-2 mb-0" />
              </div>

              <div
                className="d-flex align-items-center pointer"
                onClick={() => setShowReviews(true)}
              >
                {[...Array(5)].map((_, index) => {
                  if (index < fullStars) {
                    return <StarFill key={index} />;
                  } else if (index === fullStars && hasHalfStar) {
                    return <StarHalf key={index} />;
                  } else {
                    return <Star key={index} />;
                  }
                })}
                <p className="mx-2 mt-4">
                  {averageRating.toFixed(1)} • {totalReviews} reviews
                </p>
              </div>

              <hr className="mb-3 mt-0" width="50%" />
              <p>
                This is an example of what your club page could look like on
                Membotic. Please take note of the layout and features, including
                payment options, posts, and timetables. Use this as a guide when
                setting up your own club
              </p>

              <div className="d-flex">
                <div className="d-flex icon-container">
                  <TelephoneFill className="icon" />
                </div>
                <p className="mx-2 my-2 fw-bold">01227 12345</p>
              </div>

              <div className="d-flex mt-2">
                <div className="d-flex icon-container">
                  <Envelope className="icon" />
                </div>
                <p className="mx-2 my-2 fw-bold">example@email.com</p>
              </div>

              <div className="d-flex mt-2">
                <div className="d-flex icon-container">
                  <BrowserEdge className="icon" />
                </div>
                <p className="mx-2 my-2 fw-bold">www.example.com</p>
              </div>

              <div className="my-4">
                <div className="d-flex">
                  <a href="#">
                    <Facebook className="social-icon" />
                  </a>
                  <a href="#">
                    <Twitter className="social-icon" />
                  </a>
                  <a href="#">
                    <Instagram className="social-icon" />
                  </a>
                </div>
                <div className="d-flex">
                  <a href="#">
                    <Linkedin className="social-icon" />
                  </a>
                  <a href="#">
                    <Tiktok className="social-icon" />
                  </a>
                </div>
              </div>
            </div>

            <>
              <div className="customNav rounded">
                <p className="p-2 fw-bold">Subscriptions</p>
              </div>

              <div>
                <div className="d-flex justify-content-between fw-bold">
                  <p className="mb-0">Monthly Fitness Pass</p>
                  <p className="mb-0">£29.99</p>
                </div>

                <p className="mt-1">Access to fitness classes and gym floor</p>
                <p>Monthly recurring payment</p>

                <p className="oc-red-button p-1 fw-bold">Subscribe</p>

                <p className="text-muted mt-4">
                  This subscription provides access to all classes of this club.
                </p>
              </div>

              <hr />

              <div className="customNav rounded">
                <p className="p-2 fw-bold">Flexible Class Passes</p>
              </div>

              <div>
                <div className="d-flex justify-content-between fw-bold">
                  <p className="mb-0">5 Class Pack</p>
                  <p className="mb-0">£12.00</p>
                </div>

                <p className="mt-1">Use for any fitness class</p>
                <p className="fw-bold red-text mb-0">Classes: 5</p>
                <p className="text-muted mt-0">
                  Book 5 classes whenever you like.
                </p>

                <p className="oc-red-button p-1 fw-bold pointer">Buy</p>

                <p className="text-muted mt-4">
                  This payment option provides access to a limited selection of
                  classes. Click "
                  <span
                    style={{
                      color: "blue",
                      cursor: "pointer",
                      fontWeight: "normal",
                      textDecoration: "underline",
                    }}
                  >
                    View Class Access
                  </span>
                  " to see the available options.
                </p>
              </div>
            </>
          </div>
        </div>
        <div className="col">
          <div className="">
            <div className="row">
              {/* First Image - Full Column */}
              <div className="col-12 image-container pointer">
                <img src={Example1} alt="Club Image" className="main-image" />
              </div>

              {/* Next Images - Split Into Columns */}
              <div className="col-12 d-flex flex-wrap mt-2">
                {[
                  Example2,
                  Example3,
                  Example4,
                  Example5,
                  Example6,
                  Example7,
                ].map((img, index) => (
                  <div
                    key={index}
                    className="col-4 p-1 image-container pointer"
                  >
                    <img
                      src={img}
                      alt={`Example ${index + 2}`}
                      className="square-crop w-100"
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="posts-container"></div>
          </div>

          <div className="mt-3">
            <div>
              <div className="customNav rounded">
                <p className="p-2 fw-bold">Posts</p>
              </div>

              {/* Static Pinned Post */}
              <div className=" p-2">
                <div className="d-flex justify-content-between">
                  <p className="mb-0 fw-bold fontSize20">
                    🧷 Pinned: Club Updates This Week
                  </p>
                  <span className="mx-2">•••</span>
                </div>
                <p className="text-muted mt-0">2025-05-06</p>
                <p>
                  Don't miss the yoga session on Thursday and our brand new
                  bootcamp on Saturday!
                </p>

                <div className="d-flex">
                  <div className="post-image-container image-container pointer">
                    <img className="post-image" src={Post1} alt="Example 1" />
                  </div>

                  <div className="post-image-container image-container pointer with-overlay">
                    <img className="post-image" src={Post2} alt="Example 2" />
                    <div className="post-overlay">+2</div>
                  </div>
                </div>
              </div>

              {/* Static Scrollable Posts */}
              <div className="scrollable-posts mt-3">
                {/* Post 1 */}
                <div className=" p-2">
                  <div className="d-flex justify-content-between">
                    <p className="mb-0 fw-bold fontSize20">Bootcamp is back!</p>
                    <span className="mx-2">•••</span>
                  </div>
                  <p className="text-muted mt-0">2025-05-05</p>
                  <p>
                    Join our Saturday morning bootcamp at 9:00am for an outdoor
                    blast!
                  </p>
                </div>

                {/* Post 2 */}
                <div className=" p-2 mt-2">
                  <div className="d-flex justify-content-between">
                    <p className="mb-0 fw-bold fontSize20">
                      New Equipment Arrived
                    </p>
                    <span className="mx-2">•••</span>
                  </div>
                  <p className="text-muted mt-0">2025-05-03</p>
                  <p>
                    We’ve added new rowers and assault bikes to the gym floor.
                    Come try them!
                  </p>
                </div>

                {/* View More Button */}
                <button className="booked-button p-1 fw-bold mt-3">
                  View more
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-2 pb-2">
        <div className="customNav row mx-2">
          <div className="col mt-2">
            <p className="fw-bold fontSize20">Classes</p>
          </div>
          <div className="col mt-3">
            <p>May 6 - May 12</p>
          </div>
          <div className="col d-flex justify-content-end mt-3">
            <div className="d-flex mx-3 cursor-pointer">
              <p>Previous</p>
            </div>
            <div className="d-flex cursor-pointer">
              <p>Next</p>
            </div>
          </div>
        </div>

        <div className="row timetable mx-5">
          {/* Monday */}
          <div className="col p-0">
            <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
              <p className="px-5">Monday</p>
              <p className="mb-0">6 May</p>
            </div>

            <div className="classes-container maxWidthTimetable">
              <div className="class-content text-center">
                <p className="fontSize20">Yoga</p>
                <p className="fontSize12">Relaxing full-body flow</p>
                <p className="fontSize14">Time in: 10:00</p>
                <p className="fontSize14">Time out: 11:00</p>
                <p>Spaces left: 5</p>
                <p className="book-button mx-2 mt-2 mb-4">Book now</p>
              </div>
            </div>
          </div>

          {/* Tuesday */}
          <div className="col p-0">
            <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
              <p className="px-5">Tuesday</p>
              <p className="mb-0">7 May</p>
            </div>

            <div className="classes-container maxWidthTimetable">
              <div className="class-content text-center">
                <p className="fontSize20">HIIT</p>
                <p className="fontSize12">High-intensity cardio blast</p>
                <p className="fontSize14">Time in: 18:00</p>
                <p className="fontSize14">Time out: 18:45</p>
                <p>Spaces left: 0</p>
                <p className="booked-button mx-2 mt-2 mb-4">Fully booked</p>
              </div>
            </div>
          </div>

          {/* Wednesday */}
          <div className="col p-0">
            <div className="timetable-wkday text-center rounded-top maxWidthTimetable">
              <p className="px-5">Wednesday</p>
              <p className="mb-0">8 May</p>
            </div>

            <div className="classes-container maxWidthTimetable">
              <div className="class-content text-center">
                <p className="fontSize20">Pilates</p>
                <p className="fontSize12">Core strengthening class</p>
                <p className="fontSize14">Time in: 14:30</p>
                <p className="fontSize14">Time out: 15:15</p>
                <p>Spaces left: 2</p>
                <p className="book-button mx-2 mt-2 mb-4">Book now</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
